// eslint-disable-next-line
export default {
  id: 'frango_ninja',
  type: 'ninja',
  title: "Frango (Ninja's Version)",
  ingredients: [
    '1 peito de frango',
    '1 limão',
    '? sal ou shoyo',
    '? pimenta do reino',
    '? paprika',
    '? mostarda',
  ],
  parts: [
    {
      title: "Frango (Ninja's Version)",
      methodOfPreparation: [
        'Coloque limão, sal ou shoyo, pimenta do reino, um pouco de mostarda e paprika dos dois lados do frango',
        'Deixe um tempo para pegar o gosto',
        'Coloque na air fryer em 180 graus por 15 minutos',
      ],
    },
  ],
};
